import { Box, Text, WizardStepRenderParams } from '@factorialco/deprecated-design-system'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useEffect } from 'modules/core/hooks/useEffect'
import { track, trackingEvents } from 'modules/core/lib/Tracking'
import i18n from 'modules/core/lib/i18n'

import { WizardData } from 'modules/benefits/pages/EmployeesPage/ActivateBenefitsModal/types'
import { EmployeeSelectorV2 } from 'modules/employees/components/EmployeeSelectorV2'
import { EmployeeSelectorV2MultiSelectState } from 'modules/employees/components/EmployeeSelectorV2/types'

import { useBenefitsEmployeeSelector } from './useBenefitsEmployeeSelector'

interface BenefitsEmployeeSelectorStepProps extends WizardStepRenderParams<WizardData> {
  employeeIdsWithBenefits: number[]
}

export const BenefitsEmployeeSelectorStep = ({
  data,
  onDataChanged,
  employeeIdsWithBenefits,
}: BenefitsEmployeeSelectorStepProps) => {
  const { company } = useCurrentSession()

  const { loading, legalEntityIds, resolveSelectionAndBuildDetailsMap } =
    useBenefitsEmployeeSelector(company.id, employeeIdsWithBenefits)

  const handleSelectionChange = async (state: EmployeeSelectorV2MultiSelectState) => {
    const { resolvedSelection, employeeDetailsMap } = await resolveSelectionAndBuildDetailsMap(
      state
    )

    onDataChanged({
      ...data,
      employee_selection: resolvedSelection,
      employee_details_map: employeeDetailsMap,
    })
  }

  useEffect(() => {
    track(trackingEvents.benefits.userLandsInBenefitsActivationEmployeeSelector, {
      companyId: company.id,
    })
  }, [company.id])

  return (
    <Box flexDirection="column" position="relative" justifyContent="center">
      <Box flexDirection="column" paddingBottom="s20">
        <Text.Normal weight="semibold" color="grey1000" size="400">
          {i18n.t('benefits.tabs.employees.activation_results.modal.select_employees.step_title')}
        </Text.Normal>
        <Text.Normal weight="normal" color="grey800" size="300">
          {i18n.t('benefits.tabs.employees.activation_results.modal.select_employees.description')}
        </Text.Normal>
      </Box>
      <EmployeeSelectorV2
        multiple
        label={i18n.t('employee_selector.select_employees')}
        onChange={handleSelectionChange}
        disabled={loading}
        forcedFilters={{
          excludeIds: employeeIdsWithBenefits,
          legalEntityIds,
        }}
        options={{ asList: true }}
      />
    </Box>
  )
}

export const validateBenefitsEmployeeSelectorStep = (data: WizardData): boolean => {
  if (data.employee_selection.type === 'manual') {
    return data.employee_selection.ids.length > 0
  }
  return true
}
